module.exports = __webpack_public_path__ + "img/48000.542fb383.jpg";